import { axios, Response } from '../index'

const deletePoint = (pointId: string): Response<null> => {
  return axios.delete(`/v1/body-points/${pointId}`)
}

export default deletePoint
